import PropTypes from 'prop-types';
import React, {Children, Component} from 'react';
import { HStack, View } from '~/native-ui';

export default class Bar extends Component {
    static propTypes = {
        contour: PropTypes.bool,
        left: PropTypes.node,
        right: PropTypes.node,
    };

    static defaultProps = {
        contour: false
    };

    render() {
        let { left, className, children, contour, right, ...other } = this.props;
        
        // let classNames  = cn([style.bar, className], {
        //     [style.contour]: contour
        // });


        return (
            <HStack {...other} alignItems="center">
                {left}
                {
                    !!Children.count(children) &&
                    <View flex={1} alignItems="flex-end">
                        {children}
                    </View>
                }
                {right}
            </HStack>
        );
    }
}
